/**
 * Generated bundle index. Do not edit.
 */

export * from './ng-tree-diagram';

export {TreeComponent as ɵa} from './lib/tree.component';